import React, {useContext} from 'react';
import OutputLine from "./OutputLine";
import MobXContext from "../../../app/mobx/MobXContext";
import {observer} from "mobx-react";
import headerSize from "../../../../../../src/js/misc/headerSize";
import PropTypes from "prop-types";

const propTypes = {
	baseIndent: PropTypes.number.isRequired,
};
const defaultProps = {};

const HeaderSizeOutput = ({baseIndent}) => {
	const {configuratorStore} = useContext(MobXContext);
	const key = Object.keys(headerSize).filter(sizeKey => headerSize[sizeKey] === configuratorStore.headerSize).shift();
	return (
		<>
			{
				(key && (headerSize[key] !== headerSize.SMALL)) ?
					<OutputLine indent={baseIndent} highlightableField="headerSize">
						{`headerSize: window.utahHeader.HEADER_SIZE.${key},`}
					</OutputLine>
					: null
			}

			{
				configuratorStore.onHeaderResize ?
					<OutputLine indent={baseIndent} highlightableField="onHeaderResize">
						{`onHeaderResize: ${configuratorStore.onHeaderResize},`}
					</OutputLine>
					: null
			}
		</>
	);
};

HeaderSizeOutput.propTypes = propTypes;
HeaderSizeOutput.defaultProps = defaultProps;

export default observer(HeaderSizeOutput);
